// Imágenes reales de SO KLAR (Drive FABRICA DE ADS/SO SUECIA, público). Reemplazar por Recursos de Impultienda cuando exista la tienda.
export const PRODUCT_IMAGE = 'https://lh3.googleusercontent.com/d/1HOKf3DB2DPY55M6wBckL8Ik40ZwPk7Ce=s1400';

export const pageSamples: Array<{ src: string; label: string; title: string; text: string }> = [{
  src: 'https://lh3.googleusercontent.com/d/19u9W0kek9ALeVm87csTC_q7l1LU6qcJP=s1200',
  label: 'Lärarsida – lektion minut för minut',
  title: 'Lektion 5: Vikingatiden – handel och resor (åk 4)',
  text: 'En hel lektion på 60 minuter planerad steg för steg – mål, material, minut för minut och exakt vad du säger.'
}, {
  src: 'https://lh3.googleusercontent.com/d/119mQvHzF-w1iUdiQzJXvPeEQJEJVH7Tx=s1200',
  label: 'Elevblad i 3 nivåer',
  title: 'Klimat och vegetationszoner (åk 7)',
  text: 'Samma mål i tre nivåer – stöd, standard och utmaning – med facit för läraren.'
}, {
  src: 'https://lh3.googleusercontent.com/d/1dv1ImqyTKHjy0dD5zMrC0BPQYiGsQVB5=s1200',
  label: 'Årsplanering',
  title: 'Årsplanering åk 7–9',
  text: 'Arbetsområden i geografi, historia, religionskunskap och samhällskunskap fördelade över läsåret.'
}, {
  src: 'https://lh3.googleusercontent.com/d/1mPJPvkUQluLTHuw8IkHwoxvvZOE0Y9C1=s1200',
  label: 'Prov med facit',
  title: 'Prov åk 7–9',
  text: 'Färdigt prov med facit i lärarexemplaret för snabb rättning och genomgång.'
}, {
  src: 'https://lh3.googleusercontent.com/d/1k08wmW602yVnPTOJFbDi2tyyPDpGPStZ=s1200',
  label: 'Bedömningsmatris',
  title: 'Bedömningsmatris E/C/A',
  text: 'Tydliga kriterier för bedömning – och för åk 1–3: ”på väg / når målen / fördjupar”.'
}];
